import { IScoreCategory } from "store/slices/admin/assessments-and-reports/assessments-and-reports-model";

export const ScoreCategoryInitial: IScoreCategory = {
    code: '',
    name: '',
    position: undefined,
    scoring_type: undefined
}